export default __webpack_public_path__ + "static/media/pricing1.032a34a3.png";